<template>
<div class="row">
  <div class="col-md-10 col-md-offset-1">

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Configurações API</h4>
      </div>
      <div class="card-content">
        <div class="form-group">
          <p class="category"><strong>URL</strong> do Projeto</p>
          <input
            type="text"
            name="url"
            v-validate="modelValidations.url"
            v-model="model.url"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <p class="category"><strong>Token</strong> de autenticação do Projeto</p>
          <input
            type="text"
            name="token"
            v-validate="modelValidations.token"
            v-model="model.token"
            class="form-control"
          >
        </div>
      </div>
    </div>

    <div
      class='text-right'
      style="margin-bottom: 30px;"
    >
      <button
        v-if="$can('project.edit|projectCreate')"
        :disabled="saving"
        type="submit"
        @click.prevent="handleSave"
        class="btn btn-fill btn-success btn-wd"
      ><i class="ti-save"></i> Salvar
      </button>
    </div>
  </div>
</div>

</template>
<script>
import { mapFields } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ApiForm',

  data () {
    return {
      indexPath: { name: 'api.index' },
      saving: false,
      model: {}
    }
  },

  computed: {
    ...mapFields({
      url: 'url',
      token: 'token'
    }),
    ...mapGetters('api', {
      modelValidations: 'validations',
      loading: 'loading'
    })
  },

  mounted () {
    this.fetchAll().then(apis => {
      if (apis.length > 0) {
        this.model = Object.assign({}, apis[0])
      }
    })
  },

  methods: {
    ...mapActions('api', [
      'fetchAll',
      'fetchOne',
      'resetOne',
      'upset'
    ]),
    ...mapActions(['setConfig']),
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    handleSave () {
      this.saving = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.runSave()
        }
      }).catch(err => {
        console.log(err)
        this.saving = false
      })
    },
    runSave () {
      let doc = Object.assign({}, this.model)
      this.upset(doc)
        .then(() => {
          this.$notify({
            message: 'Registro atualizado com sucesso.',
            type: 'success'
          })
          this.$router.push(this.indexPath)
          this.saving = false
        })
        .catch(err => {
          console.log(err)
          this.saving = false
        })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Api/ApiForm.vue